/**
 * Quotes, Public Quotes, Quote Attempts, Quote Editor,
 * Quote Sender Emails, Quote Notification Emails endpoints
 */

import { contactFicheQuery } from '../../utils/contactRoute.js'

export const quotesEndpoints = {
  list: () => '/api/quotes',
  detail: (id) => `/api/quotes/${id}`,
  commercialAdvice: (id) => `/api/quotes/${id}/commercial-advice`,
  create: () => '/api/quotes',
  update: (id) => `/api/quotes/${id}`,
  delete: (id) => `/api/quotes/${id}`,
  assign: (id) => `/api/quotes/${id}/assign`,
  status: (id) => `/api/quotes/${id}/status`,
  history: (id) => `/api/quotes/${id}/history`,
  duplicates: (id) => `/api/quotes/${id}/duplicates`,
  unpaidHistory: (id) => `/api/quotes/${id}/unpaid-history`,
  linkedCompanies: (id) => `/api/quotes/${id}/linked-companies`,
  similarCompaniesAi: (id) => `/api/quotes/${id}/linked-companies/ai`,
  documents: (id) => `/api/quotes/${id}/documents`,
  downloadDocument: (id, docId) => `/api/quotes/${id}/documents/${docId}/download`,
  deleteDocument: (id, docId) => `/api/quotes/${id}/documents/${docId}`,
  // Documents joints aux réponses du questionnaire de qualification.
  reponseDocuments: (id) => `/api/quotes/${id}/reponse-documents`,
  downloadReponseDocument: (id, docId) => `/api/quotes/${id}/reponse-documents/${docId}/download`,
  deleteReponseDocument: (id, docId) => `/api/quotes/${id}/reponse-documents/${docId}`,
  sendAvailabilityRequest: (id) => `/api/quotes/${id}/send-availability-request`,
  proposePhoneAppointment: (id) => `/api/quotes/${id}/propose-phone-appointment`,
  markNotInterested: (id) => `/api/quotes/${id}/mark-not-interested`,
  scheduleRelance: (id) => `/api/quotes/${id}/schedule-relance`,
  callAssignment: (id) => `/api/quotes/${id}/call-assignment`,
  nextAction: (id) => `/api/quotes/${id}/next-action`,
  // « Fait » : efface la prochaine action ET en garde une trace complétée
  // dans user_tasks, là où PATCH next-action avec une date nulle efface
  // sans rien laisser.
  completeNextAction: (id) => `/api/quotes/${id}/next-action/complete`,
  refreshCompanyData: (id) => `/api/quotes/${id}/refresh-company-data`,
  searchClients: () => '/api/quotes/search-clients',
  searchForAppointment: () => '/api/quotes/search-for-appointment',
  tasksToday: () => '/api/quotes/tasks/today',
  triageCounts: () => '/api/quotes/triage/counts',
  stats: {
    summary: () => '/api/quotes/stats/summary',
    charts: () => '/api/quotes/stats/charts',
    statusTransitions: () => '/api/quotes/stats/status-transitions',
    statusTransitionTime: (fromStatus, toStatus) => `/api/quotes/stats/status-transition-time?fromStatus=${encodeURIComponent(fromStatus)}&toStatus=${encodeURIComponent(toStatus)}`
  },
  entreprises: {
    list: () => '/api/quotes/entreprises'
  },
  contacts: {
    list: () => '/api/quotes/contacts',
    detail: (email, siret, perimetre) => `/api/quotes/contacts/${encodeURIComponent(email)}${contactFicheQuery(siret, perimetre)}`,
    calls: (email, siret, perimetre) => `/api/quotes/contacts/${encodeURIComponent(email)}/calls${contactFicheQuery(siret, perimetre)}`,
    automaticEmails: (email, siret, perimetre) => `/api/quotes/contacts/${encodeURIComponent(email)}/automatic-emails${contactFicheQuery(siret, perimetre)}`,
    upcomingEmails: (email, siret, perimetre) => `/api/quotes/contacts/${encodeURIComponent(email)}/upcoming-emails${contactFicheQuery(siret, perimetre)}`,
    linkedCompanies: (email, siret) => `/api/quotes/contacts/${encodeURIComponent(email)}/linked-companies${contactFicheQuery(siret)}`,
    similarCompaniesAi: (email, siret) => `/api/quotes/contacts/${encodeURIComponent(email)}/linked-companies/ai${contactFicheQuery(siret)}`,
    update: (email, siret, perimetre) => `/api/quotes/contacts/${encodeURIComponent(email)}${contactFicheQuery(siret, perimetre)}`,
    communications: (email) => `/api/quotes/contacts/${encodeURIComponent(email)}/communications`
  },
  export: {
    csv: () => '/api/exports/quotes/csv',
    excel: () => '/api/exports/quotes/excel',
    pdf: (id) => `/api/exports/quotes/${id}/pdf`,
    statsPDF: () => '/api/exports/stats/pdf'
  }
}

export const publicQuotesEndpoints = {
  create: () => '/api/public/quotes',
  questionsQualification: () => '/api/public/quotes/questions-qualification',
  sign: () => '/api/public/quotes/sign',
  signPreview: () => '/api/public/quotes/sign-preview',
  calendar: () => '/api/public/quotes/calendar',
  appointment: () => '/api/public/quotes/appointment',
  // Créneaux libres d'un jour, servis sans session (routeur des rendez-vous)
  appointmentSlots: () => '/api/appointments/public/slots'
}

export const quoteAttemptsEndpoints = {
  start: () => '/api/public/quote-attempts/start',
  updateProgress: (sessionId) => `/api/public/quote-attempts/${sessionId}/progress`,
  complete: (sessionId) => `/api/public/quote-attempts/${sessionId}/complete`,
  abandon: (sessionId) => `/api/public/quote-attempts/${sessionId}/abandon`,
  analytics: () => '/api/quote-attempts/analytics',
  list: () => '/api/quote-attempts',
  detail: (id) => `/api/quote-attempts/${id}`
}

export const quoteEditorEndpoints = {
  lineDesignations: () => '/api/quote-line-designations',
  editorData: (quoteId) => `/api/quotes/${quoteId}/editor-data`
}

export const quoteSenderEmailsEndpoints = {
  list: () => '/api/quote-confirmation-sender-emails',
  create: () => '/api/quote-confirmation-sender-emails',
  update: (id) => `/api/quote-confirmation-sender-emails/${id}`,
  delete: (id) => `/api/quote-confirmation-sender-emails/${id}`
}

export const quoteNotificationEmailsEndpoints = {
  list: () => '/api/quote-notification-emails',
  create: () => '/api/quote-notification-emails',
  update: (id) => `/api/quote-notification-emails/${id}`,
  delete: (id) => `/api/quote-notification-emails/${id}`
}

export const lossReasonsEndpoints = {
  list: () => '/api/loss-reasons'
}

export const clientCcContactsEndpoints = {
  list: (email) => `/api/client-cc-contacts?email=${encodeURIComponent(email)}`,
  save: () => '/api/client-cc-contacts'
}
